import { render, staticRenderFns } from "./ChartBox.vue?vue&type=template&id=c727bcfc&scoped=true"
import script from "./ChartBox.vue?vue&type=script&lang=js"
export * from "./ChartBox.vue?vue&type=script&lang=js"
import style0 from "./ChartBox.vue?vue&type=style&index=0&id=c727bcfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c727bcfc",
  null
  
)

export default component.exports